var _templateObject = _taggedTemplateLiteralLoose(['\n  box-sizing: border-box;\n  height: 48px;\n  width: 100%;\n  border: none;\n  border-top: 1px solid #f0f0f0;\n  outline-style: inherit;\n  text-indent: 16px;\n  background: #ffffff;\n  font-size: 14px;\n  z-index: 99999;\n  border-radius: 0;\n\n  @media (min-width: 600px) {\n    width: ', ';\n    border-radius: 0 0 6px 6px;\n  }\n'], ['\n  box-sizing: border-box;\n  height: 48px;\n  width: 100%;\n  border: none;\n  border-top: 1px solid #f0f0f0;\n  outline-style: inherit;\n  text-indent: 16px;\n  background: #ffffff;\n  font-size: 14px;\n  z-index: 99999;\n  border-radius: 0;\n\n  @media (min-width: 600px) {\n    width: ', ';\n    border-radius: 0 0 6px 6px;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';

var TextBox = function TextBox(props) {
  return React.createElement('input', {
    id: '__chatbot-text-box',
    className: props.className,
    type: 'text',
    onKeyPress: props.onKeyPress,
    placeholder: props.loading ? 'Carico...' : 'Scrivi la tua domanda...',
    disabled: props.loading,
    autoFocus: false
  });
};

var StyledTextBox = styled(TextBox)(_templateObject, function (props) {
  return props.theme.width;
});

export default StyledTextBox;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@hype/chatbot/es/components/text-box.js
// module id = 220
// module chunks = 1